import {UserList} from './user-list';

export default UserList;